//offer.js
import { apiBaseUrl } from './config.js';
import { t, confirmT, updateElementText } from './translationHelper.js';

const tr = t;

import { showNotification, updateTotalPointsDisplay, showPopupPoints, clearLEDDisplay } from './notif.js';
import { getAuthToken } from './auth.js';

function getPortfolioId() {
  return localStorage.getItem('portfolioId');
}

function unblockUI() {
  // reset body
  document.body.style.overflow = '';
  document.body.style.pointerEvents = '';

  // nuke any stray overlays/popups we create
  ['offerSentOverlay','offerSentPopup','tradeOfferPopup','popup-container','social-trade-dialog']
	.forEach(id => {
	  const el = document.getElementById(id);
	  if (el && el.parentNode) el.parentNode.removeChild(el);
	});

  // belt + suspenders: remove any full-screen divs we created with huge z-index
  [...document.querySelectorAll('div')]
	.filter(el => {
	  const s = getComputedStyle(el);
	  return (socket.position === 'fixed' || s.position === 'absolute') &&
			 parseInt(s.zIndex || '0', 10) >= 9999 &&
			 (el.id || '').includes('overlay');
	})
	.forEach(el => el.parentNode && el.parentNode.removeChild(el));
}
window.forceUnblockUI = unblockUI; // handy for debugging in console


export function showItemReceivedNotification(giverName, itemName) {
  const message = t('offer.item_received', 'You received {item} from {giver}!')
	.replace('{item}', itemName)
	.replace('{giver}', giverName);
  showNotification(message, true);
}

export function showOfferSentPopup(portfolioId, knownItemIdsAtPageLoad) {
  // Guard: only show if an offer was just sent (flag set by your send flow)
  if (localStorage.getItem('pendingOffer') !== 'true') return;

  // Prevent duplicates if somehow called twice
  if (document.getElementById('offerSentPopup')) return;

  // --- Overlay & popup
  const overlay = document.createElement('div');
  overlay.id = 'offerSentOverlay'; // ADD ID so it can be cleaned up externally
  overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";
  document.body.appendChild(overlay);

  const popup = document.createElement('div');
  popup.id = 'offerSentPopup';
  popup.style = "position: relative; width:100%; max-width: 100%; height: 100%; max-height: 100%; padding: 20px; border-radius: 0px; border: 2px solid #00ff00; color: #00ff00; font-family: 'bithigh', sans-serif; text-align: center; z-index: 10001; overflow: hidden; display: flex; justify-content: center; align-items: center;";
  overlay.appendChild(popup);

  if (window.popupTracker) window.popupTracker.trackElement(popup, 'offer-sent');

  // --- Background video container
  const videoContainer = document.createElement('div');
  videoContainer.style = "position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: -1;";
  popup.appendChild(videoContainer);

  // --- Content
  const content = document.createElement('div');
  content.style = "position: relative; z-index: 1; padding: 20px; background-color: rgba(1, 32, 59, 0.7); border-radius: 3px; max-width: 80%;";
  content.innerHTML = `
	<h2>${t('offer.offer_sent', 'Offer Sent')} <br><br> ${t('offer.do_not_leave_page', 'DO NOT LEAVE PAGE.')} <br><br></h2>
	<p>${t('offer.awaiting_response', 'Awaiting response. Please wait...')}</p>
	<p id="offerSentTimerText"></p>
  `;
  popup.appendChild(content);

  // Initialize timer line as PLAIN TEXT (no inner HTML templating)
  const timerP = content.querySelector('#offerSentTimerText');
  const timerLine = (sec) => t('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', String(sec));
  timerP.textContent = timerLine(10);

  // --- Background HLS (with robust fallback)
  const videoBaseUrl = `${apiBaseUrl}/uploads/specialBacks/itemTrade/`;
  const totalVideos = 10;
  let currentVideoIndex = 0;
  let hlsInstance = null;
  let videoInterval = null;
  let interval = null;
  let isCleanedUp = false; // ADD FLAG to prevent duplicate cleanup

  function loadRandomVideo() {
	currentVideoIndex = Math.floor(Math.random() * totalVideos) + 1;
	loadVideo();
  }

  function loadVideo() {
	if (!document.body.contains(overlay)) return; // already closed

	const videoUrl = `${videoBaseUrl}${currentVideoIndex}/playlist.m3u8`;
	const video = document.createElement('video');
	video.style = "position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; pointer-events: none; z-index: -1;";
	video.setAttribute('playsinline', 'true');
	video.setAttribute('webkit-playsinline', 'true');
	video.setAttribute('muted', 'true');
	video.setAttribute('autoplay', 'true');
	video.setAttribute('loop', 'true');
	video.setAttribute('controls', 'false');
	video.setAttribute('disablePictureInPicture', 'true');
	video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplaybook');
	video.setAttribute('x-webkit-airplay', 'deny');
	video.setAttribute('preload', 'metadata');
	video.muted = true;
	video.controls = false;
	video.playsInline = true;
	video.tabIndex = -1;

	const preventEvent = (e) => { e.preventDefault(); e.stopPropagation(); return false; };
	['contextmenu','touchstart','touchend','touchmove','click','dblclick','mousedown','mouseup','mousemove','focus','blur'].forEach(ev => {
	  video.addEventListener(ev, preventEvent, { passive: false });
	});
	['webkitfullscreenchange','fullscreenchange','webkitbeginfullscreen','webkitendfullscreen'].forEach(ev => {
	  video.addEventListener(ev, preventEvent);
	});

	// Tear down any existing HLS instance
	if (hlsInstance) {
	  try { hlsInstance.destroy(); } catch {}
	  hlsInstance = null;
	}

	if (window.Hls && Hls.isSupported()) {
	  hlsInstance = new Hls();
	  hlsInstance.loadSource(videoUrl);
	  hlsInstance.attachMedia(video);
	  hlsInstance.on(Hls.Events.MANIFEST_PARSED, () => video.play().catch(() => {}));
	  hlsInstance.on(Hls.Events.ERROR, (event, data) => {
		console.error('HLS error:', data);
		if (data?.fatal) loadRandomVideo();
	  });
	} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
	  video.src = videoUrl;
	  video.addEventListener('loadedmetadata', () => video.play().catch(() => {}));
	  video.addEventListener('error', () => loadRandomVideo());
	}

	videoContainer.innerHTML = '';
	videoContainer.appendChild(video);
  }

  loadRandomVideo();
  videoInterval = setInterval(loadRandomVideo, 10000);

  // --- Countdown (UI-only)
  let timeLeft = 10;

  function cleanup() {
	if (isCleanedUp) return;
	isCleanedUp = true;

	try { if (interval) clearInterval(interval); } catch {}
	try { if (videoInterval) clearInterval(videoInterval); } catch {}
	try { if (hlsInstance) hlsInstance.destroy(); } catch {}
	hlsInstance = null;
	interval = null;
	videoInterval = null;

	localStorage.removeItem('pendingOffer');

	// Unregister popups from popupTracker before removing
	if (window.popupTracker) {
	  try {
		window.popupTracker.unregisterPopup('offerSentPopup');
		window.popupTracker.unregisterPopup('offerSentOverlay');
	  } catch (e) {
		console.warn('Error unregistering popups:', e);
	  }
	}

	if (overlay && overlay.parentNode) {
	  overlay.parentNode.removeChild(overlay);
	}

	const overlayById = document.getElementById('offerSentOverlay');
	if (overlayById && overlayById.parentNode) {
	  overlayById.parentNode.removeChild(overlayById);
	}

	const popupById = document.getElementById('offerSentPopup');
	if (popupById && popupById.parentNode) {
	  popupById.parentNode.removeChild(popupById);
	}

	// Navigate away after cleanup — back to the 3D floor if that is where the
	// swap was started from (it sets zxReturnTo), otherwise the classic page.
	// zxReturnTo is CONSUMED by whoever reads it first, and on this page
	// zxTakeReturn() is racing us. Falling through to the hardcoded 'trader.html'
	// is how a floor user ends up stranded on the classic page. goTrade() also
	// mirrors the destination into sessionStorage, which nothing consumes — so
	// check that before giving up.
	setTimeout(() => {
	  if (location.pathname.endsWith('/transaction.html')) {
		const target = localStorage.getItem('zxReturnTo');
		if (target) localStorage.removeItem('zxReturnTo');
		let mirrored = null;
		try { mirrored = sessionStorage.getItem('zxReturnTo'); } catch (_) {}
		window.location.href = target || mirrored || 'trader.html';
	  }
	}, 100);
  }
  
  // Make cleanup accessible globally for external calls
  window.cleanupOfferSentPopup = cleanup;
  
  window.handleOfferAccepted = () => { cleanup(); showNotification(t('offer.offer_accepted','Offer accepted!'), true); };
  window.handleOfferDeclined = () => { cleanup(); showNotification(t('offer.offer_declined','Offer declined.'), false); };
  
  // Ensure fast unload → no lag on trader.js
  const onPageHide = () => cleanup();
  const onBeforeUnload = () => cleanup();
  const onVis = () => { if (document.hidden) cleanup(); };
  window.addEventListener('pagehide', onPageHide, { once: true });
  window.addEventListener('beforeunload', onBeforeUnload, { once: true });
  document.addEventListener('visibilitychange', onVis, { once: true });

  interval = setInterval(() => {
	if (isCleanedUp) return; // Stop if already cleaned up

	timeLeft -= 1;
	if (timeLeft < 0) timeLeft = 0;

	if (document.body.contains(overlay) && timerP) {
	  timerP.textContent = timerLine(timeLeft);
	}

	if (timeLeft === 0) {
	  // Store notification for display after redirect to trader.html
	  const msg = t('offer.still_waiting', 'Still waiting for a response…');
	  try {
		localStorage.setItem('pendingNotification', JSON.stringify({
		  message: msg,
		  success: false,
		  ts: Date.now()
		}));
	  } catch (_) {}
	  cleanup();
	}
  }, 1000);
}

	
export function showOfferPopup(offerData, portfolioId, timeoutDuration = 10000) {
  try { window.__removeWaitingPopup?.(); } catch {}
  document.getElementById('waitingPopup')?.remove();

  console.log('Attempting to show offer popup:', offerData);
  if (!offerData) return;

  // Clean up any previous trade session when a new offer arrives
  const currentActiveSession = localStorage.getItem('activeTradeSession');
  if (currentActiveSession) {
    console.log('Clearing previous trade session:', currentActiveSession);
    localStorage.setItem(`${currentActiveSession}_active`, 'false');
    localStorage.removeItem(`${currentActiveSession}_offerData`);
    localStorage.removeItem(`${currentActiveSession}_expiryTime`);
  }

  const tradeSessionId = `trade_${offerData.offeredItemId}_${offerData.transactionItemId}_${Date.now()}`;
  localStorage.setItem('activeTradeSession', tradeSessionId);
  localStorage.setItem(`${tradeSessionId}_active`, 'true');
  localStorage.setItem(`${tradeSessionId}_offerData`, JSON.stringify(offerData));

  let tradeActive = true;
  let timerInterval = null;

  // Remove existing popup if present
  const old = document.getElementById('tradeOfferPopup');
  if (old) old.remove();

  const popup = document.createElement('div');
  popup.id = 'tradeOfferPopup';
  popup.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00; overflow-y: auto; overflow-x: hidden;
	-webkit-overflow-scrolling: touch; padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  `;
  document.body.appendChild(popup);
  document.body.style.overflow = 'hidden';

  if (window.popupTracker) window.popupTracker.trackElement(popup, 'trade-offer');

  // Background video
  const video = document.createElement('video');
  video.id = 'offerPopupBackground';
  video.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: -1; pointer-events: none; background:#000;
  `;
  ['playsinline','webkit-playsinline','muted','autoplay','loop','controls','disablePictureInPicture','preload','x-webkit-airplay']
	.forEach(attr => video.setAttribute(attr, attr === 'controls' ? 'false' : attr === 'preload' ? 'metadata' : 'true'));
  video.muted = true; video.controls = false; video.playsInline = true; video.tabIndex = -1;
  const preventEvent = (e)=>{e.preventDefault();e.stopPropagation();return false;};
  ['contextmenu','touchstart','touchend','touchmove','click','dblclick','mousedown','mouseup','mousemove','focus','blur']
	.forEach(ev=>video.addEventListener(ev, preventEvent, {passive:false}));
  ['webkitfullscreenchange','fullscreenchange','webkitbeginfullscreen','webkitendfullscreen']
	.forEach(ev=>video.addEventListener(ev, preventEvent));
  popup.appendChild(video);

  // Story section
  const storySection = (offerData.tradeStory && offerData.hasStory) ? `
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid rgba(0, 255, 0, 0.3); border-radius: 5px; padding: 10px; margin: 15px 0;">
	  <h5 style="margin:0 0 8px 0;color:#00ff00;">${t('offer.reason', 'Reason:')}</h5>
	  <p style="margin: 0; font-style: italic; font-size: 0.7em; line-height: 1.3;">"${offerData.tradeStory}"</p>
	</div>
  ` : '';

  const content = document.createElement('div');
  content.style = "position: relative; z-index: 1; min-height: 100vh; display:flex; align-items:center; justify-content:center; padding:20px; box-sizing:border-box;";
  content.innerHTML = `
	<div class="tradeOffPop">
	  <h2>${t('offer.trade_offer', 'Trade Offer')}</h2>
	  <p class="zx-sec-explain" style="text-align:left;">${t('floor.exp_trade_offer', "A trader is proposing a straight swap: their thing for yours. The floor's bots trade too — respond exactly as you would to a person.")}</p>
	  <p>${
		t('offer.offers_you','{initiator} offers you: {offered} in exchange for: {requested}')
		.replace('{initiator}', offerData.initiatorPortfolioName)
		.replace('{offered}', offerData.offeredItemName)
		.replace('{requested}', offerData.transactionItemName)
	  }</p>
	  ${storySection}
	  ${
		storySection
		? `<div style="margin-top: 15px;">
			<button id="respondOffer" style="width: 100%; background: rgba(255, 165, 0, 0.6); color: #000; border: 1px solid #ffaa00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">
			  ${t('offer.respond', 'Respond')}
			</button>
		  </div>`
		: ''
	  }
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="acceptOffer" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${t('offer.accept', 'Accept')}</button>
		<button id="declineOffer" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${t('offer.decline', 'Decline')}</button>
	  </div>
	  <div id="timer" style="margin-top:10px;text-align:center;"></div>
	</div>
  `;
  popup.appendChild(content);

  const style = document.createElement('style');
  style.textContent = `
	.tradeOffPop {
	  position: relative !important; transform: none !important; top:auto !important; left:auto !important;
	  width: 90%; max-width: 600px; padding: 20px; background-color: rgba(0, 8, 36, 0.9);
	  border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 10000;
	  font-family: 'bithigh', Arial, sans-serif; color: #00ff00; text-align: center; margin: 0 auto;
	  box-sizing: border-box; backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px);
	}
	@media (max-width: 600px){ .tradeOffPop { width:95%; max-width:95%; padding:15px; margin:10px auto; } }
	@media (max-height: 700px){ .tradeOffPop { margin:10px auto; } }
	.tradeOffPop button { min-height:44px; touch-action:manipulation; -webkit-appearance:none; appearance:none; }
  `;
  document.head.appendChild(style);

  // Load background HLS
  const videoBaseUrl = `${apiBaseUrl}/uploads/specialBacks/itemTrade/`;
  const totalVideos = 10;
  const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
  const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;

  if (window.Hls && Hls.isSupported()) {
	const hls = new Hls({ debug:false, enableWorker:false, lowLatencyMode:true, backBufferLength:90 });
	hls.loadSource(videoUrl);
	hls.attachMedia(video);
	hls.on(Hls.Events.MANIFEST_PARSED, () => video.play().catch(()=>{ video.style.display='none'; }));
	hls.on(Hls.Events.ERROR, () => { video.style.display = 'none'; });
  } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
	video.src = videoUrl;
	video.addEventListener('loadedmetadata', () => video.play().catch(()=>{ video.style.display='none'; }));
	video.addEventListener('error', ()=>{ video.style.display='none'; });
  }

  // Timer
  const timerEl = content.querySelector('#timer');
  let remainingTime = Math.floor(timeoutDuration / 1000);
  localStorage.setItem(`${tradeSessionId}_timerType`, 'initial');
  localStorage.setItem(`${tradeSessionId}_expiryTime`, String(Date.now() + timeoutDuration));
	const renderTime = () => { if (timerEl) timerEl.textContent = t('offer.time_remaining', 'Time remaining: {seconds} seconds').replace('{seconds}', remainingTime); };
  renderTime();

  const autoDecline = () => {
	console.log('autoDecline called - checking session:', tradeSessionId);
	const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
	const currentActiveSession = localStorage.getItem('activeTradeSession');
	if (!sessionActive || currentActiveSession !== tradeSessionId || !tradeActive) return;

	// lock
	localStorage.setItem(`${tradeSessionId}_active`, 'false');
	tradeActive = false;

	const declineBtn = document.getElementById('declineOffer');
	if (declineBtn) declineBtn.disabled = true;

	declineTrade(offerData)
	  .then(() => console.log('Trade successfully auto-declined.'))
	  .catch(err => console.error('Error auto-declining trade:', err?.message || err))
	  .finally(closePopup);
  };

  timerInterval = setInterval(() => {
	const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
	const currentActiveSession = localStorage.getItem('activeTradeSession');
	if (!sessionActive || currentActiveSession !== tradeSessionId) {
	  clearInterval(timerInterval);
	  return;
	}

	const currentTimerType = localStorage.getItem(`${tradeSessionId}_timerType`);
	if (currentTimerType === 'extended') {
	  clearInterval(timerInterval);
	  return;
	}

	remainingTime -= 1;
	renderTime();

	if (remainingTime <= 0) {
	  clearInterval(timerInterval);
	  const stillActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
	  const stillInitial = localStorage.getItem(`${tradeSessionId}_timerType`) === 'initial';
	  if (stillActive && stillInitial && tradeActive) autoDecline();
	}
  }, 1000);

  // Buttons
  const acceptButton = document.getElementById('acceptOffer');
  const declineButton = document.getElementById('declineOffer');

  acceptButton.onclick = async () => {
	localStorage.setItem(`${tradeSessionId}_active`, 'false');
	if (timerInterval) clearInterval(timerInterval);
	if (!tradeActive) return;
	tradeActive = false;
	acceptButton.disabled = true;

	try {
	  await acceptTrade(offerData);
	  closePopup();
	} catch (e) {
	  console.error('Error accepting trade:', e);
	  showNotification(`${t('offer.error_accepting_offer','Error accepting offer: {message}').replace('{message}', e.message)}`, false);
	  acceptButton.disabled = false;
	  tradeActive = true;
	  localStorage.setItem(`${tradeSessionId}_active`, 'true');
	}
  };

  declineButton.onclick = async () => {
	localStorage.setItem(`${tradeSessionId}_active`, 'false');
	if (timerInterval) clearInterval(timerInterval);
	if (!tradeActive) return;
	tradeActive = false;
	declineButton.disabled = true;

	try {
	  await declineTrade(offerData);
	  closePopup();
	} catch (e) {
	  console.error('Error declining trade:', e);
	  showNotification(`${t('offer.error_declining_offer','Error declining offer: {message}').replace('{message}', e.message)}`, false);
	  declineButton.disabled = false;
	  tradeActive = true;
	  localStorage.setItem(`${tradeSessionId}_active`, 'true');
	}
  };

  // Respond (extends timer 60s and opens narrative dialog)
  if (storySection) {
	const respondButton = document.getElementById('respondOffer');
	respondButton.onclick = () => {
	  if (!tradeActive) return;
	  localStorage.setItem(`${tradeSessionId}_timerType`, 'extended');
	  localStorage.setItem(`${tradeSessionId}_expiryTime`, String(Date.now() + 60000));
	  if (timerInterval) clearInterval(timerInterval);

	  remainingTime = 60;
	  renderTime();

	  timerInterval = setInterval(() => {
		const sessionActive = localStorage.getItem(`${tradeSessionId}_active`) === 'true';
		const currentActiveSession = localStorage.getItem('activeTradeSession');
		if (!sessionActive || currentActiveSession !== tradeSessionId || !tradeActive) {
		  clearInterval(timerInterval);
		  return;
		}
		remainingTime -= 1;
		renderTime();
		if (remainingTime <= 0) {
		  clearInterval(timerInterval);
		  if (sessionActive && tradeActive) autoDecline();
		}
	  }, 1000);

	  const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	  if (s && s.connected) {
		s.emit('extendTradeTimer', {
		  offeredItemId: offerData.offeredItemId,
		  transactionItemId: offerData.transactionItemId,
		  initiatorUserId: offerData.initiatorUserId,
		  targetUserId: offerData.targetUserId,
		  newDuration: 60000
		});
	  }
	  showNarrativeResponseDialog(offerData);
	};
  }

  function closePopup() {
	localStorage.setItem(`${tradeSessionId}_active`, 'false');
	localStorage.removeItem(`${tradeSessionId}_timerType`);
	localStorage.removeItem(`${tradeSessionId}_expiryTime`);
	localStorage.removeItem(`${tradeSessionId}_offerData`);
	if (localStorage.getItem('activeTradeSession') === tradeSessionId) {
	  localStorage.removeItem('activeTradeSession');
	}
	tradeActive = false;
	if (timerInterval) clearInterval(timerInterval);
	if (window.currentTradeTimerExtension) delete window.currentTradeTimerExtension;

	const pop = document.getElementById('tradeOfferPopup');
	if (pop) {
	  // Unregister from popupTracker before removing
	  if (window.popupTracker) {
		window.popupTracker.unregisterPopup('tradeOfferPopup');
	  }
	  pop.remove();
	  document.body.style.overflow = '';
	}
  }

  // Clean up stale sessions
  const allKeys = Object.keys(localStorage);
  const fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
  allKeys.forEach(key => {
	if (key.startsWith('trade_') && key.endsWith('_expiryTime')) {
	  const expiryTime = parseInt(localStorage.getItem(key), 10);
	  if (!Number.isNaN(expiryTime) && expiryTime < fiveMinutesAgo) {
		const sessionId = key.replace('_expiryTime', '');
		localStorage.removeItem(`${sessionId}_active`);
		localStorage.removeItem(`${sessionId}_timerType`);
		localStorage.removeItem(`${sessionId}_expiryTime`);
	  }
	}
  });
}



	
export async function acceptTrade(offerData) {
  if (!offerData) throw new Error('Missing offer data');
  return new Promise((resolve, reject) => {
	const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	if (!s) return reject(new Error('Socket not available'));
	if (!s.connected) return reject(new Error('Socket is not connected'));
	s.emit('acceptTrade', {
	  offeredItemId: offerData.offeredItemId,
	  transactionItemId: offerData.transactionItemId,
	  initiatorUserId: offerData.initiatorUserId,
	  targetUserId: offerData.targetUserId,
	}, (response) => {
	  if (response && response.success) {
		console.log('Trade acceptance confirmed by server');
		showNotification(t('offer.offer_accepted', 'Offer accepted!'), true);
		resolve(response);
	  } else {
		const errorMsg = response?.error || 'No response from server';
		showNotification(`${t('offer.offer_accept_error','Error accepting offer: {message}').replace('{message}', errorMsg)}`, false);
		reject(new Error(errorMsg));
	  }
	});
  });
}

export async function declineTrade(offerData) {
  if (!offerData) throw new Error('Missing offer data');
  return new Promise((resolve, reject) => {
	const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	if (!s) return reject(new Error('Socket not available'));

	const missing = ['offeredItemId','transactionItemId','initiatorUserId','targetUserId']
	  .filter(k => !offerData[k]);
	if (missing.length) return reject(new Error('Incomplete trade data. Missing: ' + missing.join(', ')));

	if (!s.connected) return reject(new Error('Socket is not connected'));
	s.emit('declineTrade', {
	  offeredItemId: offerData.offeredItemId,
	  transactionItemId: offerData.transactionItemId,
	  initiatorUserId: offerData.initiatorUserId,
	  targetUserId: offerData.targetUserId,
	}, (response) => {
	  if (response?.success) {
		console.log('Trade declination confirmed by server');
		showNotification(t('offer.offer_declined', 'Offer declined.'), false);
		resolve(response);
	  } else {
		const errorMsg = response?.error || 'No response from server';
		showNotification(`${t('offer.offer_decline_error','Error declining offer: {message}').replace('{message}', errorMsg)}`, false);
		reject(new Error(errorMsg));
	  }
	});
  });
}

let clients = new Map();

export function showReceiveBuyOfferPopup(data) {
  console.log('Attempting to show buy offer popup:', data);
  if (!data) return;

  // Check if this offer was recently handled (prevent duplicate popups from message replay)
  const offerKey = `buyOffer_handled_${data.itemId}_${data.buyerId}`;
  const handledTime = localStorage.getItem(offerKey);
  if (handledTime && (Date.now() - parseInt(handledTime)) < 30000) {
    console.log('Skipping buy offer popup - recently handled:', offerKey);
    return;
  }

  // Clean up any previous buy offer session
  const currentBuySession = localStorage.getItem('activeBuyOfferSession');
  if (currentBuySession) {
	console.log('Clearing previous buy offer session:', currentBuySession);
	localStorage.setItem(`${currentBuySession}_active`, 'false');
	localStorage.removeItem(`${currentBuySession}_offerData`);
	localStorage.removeItem(`${currentBuySession}_expiryTime`);
  }

  const buySessionId = `buy_${data.itemId}_${data.buyerId}_${Date.now()}`;
  localStorage.setItem('activeBuyOfferSession', buySessionId);
  localStorage.setItem(`${buySessionId}_active`, 'true');
  localStorage.setItem(`${buySessionId}_offerData`, JSON.stringify(data));

  let offerActive = true;
  let timerInterval = null;

  // Remove existing popup if present
  const old = document.getElementById('buyOfferPopup');
  if (old) old.remove();

  const popup = document.createElement('div');
  popup.id = 'buyOfferPopup';
  popup.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00; overflow-y: auto; overflow-x: hidden;
	-webkit-overflow-scrolling: touch; padding: env(safe-area-inset-top,0) env(safe-area-inset-right,0) env(safe-area-inset-bottom,0) env(safe-area-inset-left,0);
  `;
  document.body.appendChild(popup);
  document.body.style.overflow = 'hidden';

  if (window.popupTracker) window.popupTracker.trackElement(popup, 'buy-offer');

  // Background video
  const video = document.createElement('video');
  video.id = 'buyOfferPopupBackground';
  video.style = `
	position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; object-fit: cover; z-index: -1; pointer-events: none; background:#000;
  `;
  ['playsinline','webkit-playsinline','muted','autoplay','loop','controls','disablePictureInPicture','preload','x-webkit-airplay']
	.forEach(attr => video.setAttribute(attr, attr === 'controls' ? 'false' : attr === 'preload' ? 'metadata' : 'true'));
  video.muted = true; video.controls = false; video.playsInline = true; video.tabIndex = -1;
  const preventEvent = (e)=>{e.preventDefault();e.stopPropagation();return false;};
  ['contextmenu','touchstart','touchend','touchmove','click','dblclick','mousedown','mouseup','mousemove','focus','blur']
	.forEach(ev=>video.addEventListener(ev, preventEvent, {passive:false}));
  ['webkitfullscreenchange','fullscreenchange','webkitbeginfullscreen','webkitendfullscreen']
	.forEach(ev=>video.addEventListener(ev, preventEvent));
  popup.appendChild(video);

  // Build offer text
  let offerText = '';
  if (data.bidType === 'points') {
	offerText = t('offer.buy_offer_points', '{portfolio} offers {amount} points for {item}')
	  .replace('{portfolio}', data.portfolioName || 'Someone')
	  .replace('{amount}', data.offerAmount)
	  .replace('{item}', data.item_name || 'your item');
  } else if (data.bidType === 'zollars') {
	offerText = t('offer.buy_offer_zollars', '{portfolio} offers zollars for {item}')
	  .replace('{portfolio}', data.portfolioName || 'Someone')
	  .replace('{item}', data.item_name || 'your item');
  } else {
	offerText = `${data.portfolioName || 'Someone'} ${t('offer.wants_to_buy','wants to buy')} ${data.item_name || 'your item'}`;
  }

  // Show buy reason if provided
  const reasonSection = data.buyReason ? `
	<div style="background: rgba(0, 255, 0, 0.1); border: 1px solid rgba(0, 255, 0, 0.3); border-radius: 5px; padding: 10px; margin: 15px 0;">
	  <h5 style="margin:0 0 8px 0;color:#00ff00;">${t('offer.reason', 'Reason:')}</h5>
	  <p style="margin: 0; font-style: italic; font-size: 0.85em; line-height: 1.3;">"${data.buyReason}"</p>
	</div>
  ` : '';

  const content = document.createElement('div');
  content.style = "position: relative; z-index: 1; min-height: 100vh; display:flex; align-items:center; justify-content:center; padding:20px; box-sizing:border-box;";
  content.innerHTML = `
	<div class="buyOfferPop">
	  <h2>${t('offer.buy_offer_received', 'Buy Offer Received')}</h2>
	  <p class="zx-sec-explain" style="text-align:left;">${t('floor.exp_buy_offer', "Someone wants something you carry and is paying for it. Accept and the payment moves to you, the thing to them; decline and you keep it.")}</p>
	  <p>${offerText}</p>
	  ${reasonSection}
	  ${data.bidType === 'zollars' ? `<div style="margin: 10px 0;">${displayZollarDetails(data.zollarBid || {})}</div>` : ''}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="acceptBuyOffer" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${t('offer.accept', 'Accept')}</button>
		<button id="declineBuyOffer" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif;">${t('offer.decline', 'Decline')}</button>
	  </div>
	  <div id="buyTimer" style="margin-top:10px;text-align:center;"></div>
	</div>
  `;
  popup.appendChild(content);

  // Setup close function first (offerKey already defined above for dedup check)
  function closePopup() {
	// Mark this offer as handled to prevent duplicate popups from message replay
	localStorage.setItem(offerKey, String(Date.now()));
	// Schedule cleanup of the handled marker after 30 seconds
	setTimeout(() => localStorage.removeItem(offerKey), 30000);

	localStorage.setItem(`${buySessionId}_active`, 'false');
	localStorage.removeItem(`${buySessionId}_expiryTime`);
	localStorage.removeItem(`${buySessionId}_offerData`);
	if (localStorage.getItem('activeBuyOfferSession') === buySessionId) {
	  localStorage.removeItem('activeBuyOfferSession');
	}
	offerActive = false;
	if (timerInterval) clearInterval(timerInterval);

	const pop = document.getElementById('buyOfferPopup');
	if (pop) {
	  if (window.popupTracker) {
		window.popupTracker.unregisterPopup('buyOfferPopup');
	  }
	  pop.remove();
	  document.body.style.overflow = '';
	}
  }

  // Setup buttons IMMEDIATELY after content is appended
  const acceptBtn = content.querySelector('#acceptBuyOffer');
  const declineBtn = content.querySelector('#declineBuyOffer');

  if (acceptBtn) {
	acceptBtn.addEventListener('click', async function(e) {
	  e.preventDefault();
	  e.stopPropagation();

	  localStorage.setItem(`${buySessionId}_active`, 'false');
	  if (timerInterval) clearInterval(timerInterval);
	  if (!offerActive) return;
	  offerActive = false;
	  this.disabled = true;

	  // Close popup immediately - don't wait for server response
	  closePopup();

	  try {
		await handleAcceptBuyOffer({
		  itemId: data.itemId,
		  buyerId: data.buyerId,
		  sellerId: data.sellerId,
		  offerAmount: data.offerAmount,
		  bidType: data.bidType,
		  zollarBid: data.zollarBid || {},
		  item_name: data.item_name
		});
	  } catch (err) {
		console.error('Error in handleAcceptBuyOffer:', err);
		showNotification(`Error: ${err.message}`, false);
	  }
	});
  }

  if (declineBtn) {
	declineBtn.addEventListener('click', function(e) {
	  e.preventDefault();
	  e.stopPropagation();

	  localStorage.setItem(`${buySessionId}_active`, 'false');
	  if (timerInterval) clearInterval(timerInterval);
	  if (!offerActive) return;
	  offerActive = false;
	  this.disabled = true;

	  // Close popup immediately - don't wait for server response
	  closePopup();
	  handleRejectBuyOffer(data);
	});
  }

  // Setup timer
  let remainingTime = 10;
  localStorage.setItem(`${buySessionId}_expiryTime`, String(Date.now() + 10000));

  const updateTimer = () => {
	const timerEl = content.querySelector('#buyTimer');
	if (timerEl) {
	  timerEl.textContent = `Time remaining: ${remainingTime} seconds`;
	}
  };
  updateTimer();

  timerInterval = setInterval(() => {
	const sessionActive = localStorage.getItem(`${buySessionId}_active`) === 'true';
	const currentSession = localStorage.getItem('activeBuyOfferSession');
	if (!sessionActive || currentSession !== buySessionId) {
	  clearInterval(timerInterval);
	  return;
	}

	remainingTime -= 1;
	updateTimer();

	if (remainingTime <= 0) {
	  clearInterval(timerInterval);
	  const stillActive = localStorage.getItem(`${buySessionId}_active`) === 'true';
	  if (stillActive && offerActive) {
		localStorage.setItem(`${buySessionId}_active`, 'false');
		offerActive = false;
		handleRejectBuyOffer(data);
		closePopup();
	  }
	}
  }, 1000);

  const style = document.createElement('style');
  style.textContent = `
	.buyOfferPop {
	  position: relative !important; transform: none !important; top:auto !important; left:auto !important;
	  width: 90%; max-width: 600px; padding: 20px; background-color: rgba(0, 8, 36, 0.9);
	  border-radius: 8px; box-shadow: 0 4px 20px rgba(0,0,0,0.5); z-index: 10000;
	  font-family: 'bithigh', Arial, sans-serif; color: #00ff00; text-align: center; margin: 0 auto;
	  box-sizing: border-box; backdrop-filter: blur(5px); -webkit-backdrop-filter: blur(5px);
	}
	@media (max-width: 600px){ .buyOfferPop { width:95%; max-width:95%; padding:15px; margin:10px auto; } }
	@media (max-height: 700px){ .buyOfferPop { margin:10px auto; } }
	.buyOfferPop button { min-height:44px; touch-action:manipulation; -webkit-appearance:none; appearance:none; }
  `;
  document.head.appendChild(style);

  // Load background HLS (using same item trade backgrounds)
  const videoBaseUrl = `${apiBaseUrl}/uploads/specialBacks/itemTrade/`;
  const totalVideos = 10;
  const videoIndex = Math.floor(Math.random() * totalVideos) + 1;
  const videoUrl = `${videoBaseUrl}${videoIndex}/playlist.m3u8`;

  if (window.Hls && Hls.isSupported()) {
	const hls = new Hls({ debug:false, enableWorker:false, lowLatencyMode:true, backBufferLength:90 });
	hls.loadSource(videoUrl);
	hls.attachMedia(video);
	hls.on(Hls.Events.MANIFEST_PARSED, () => video.play().catch(()=>{ video.style.display='none'; }));
	hls.on(Hls.Events.ERROR, () => { video.style.display = 'none'; });
  } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
	video.src = videoUrl;
	video.addEventListener('loadedmetadata', () => video.play().catch(()=>{ video.style.display='none'; }));
	video.addEventListener('error', ()=>{ video.style.display='none'; });
  }
}



function displayZollarDetails(zollarBid) {
  if (!zollarBid || Object.keys(zollarBid).length === 0) {
	return `<p>${t('offer.no_zollar_details', 'No Zollar details available.')}</p>`;
  }

  let zollarHtml = '<ul>';
  for (const [type, value] of Object.entries(zollarBid)) {
	if (value > 0) {
	  const descriptor = getQualitativeDescriptor(value);
	  zollarHtml += `<li>${type}: ${descriptor}</li>`; // Only display the descriptor
	}
  }
  zollarHtml += '</ul>';
  return zollarHtml;
}

let isProcessing = false;

export function handleAcceptBuyOffer(data) {
  return new Promise((resolve, reject) => {
	if (isProcessing) return reject(new Error('Transaction is already being processed.'));
	isProcessing = true;

	const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	const trySocketFirst = !!(s && s.connected);

	const doSocket = () =>
	  acceptBuyOfferSocket({
		itemId: data.itemId,
		buyerId: data.buyerId,
		sellerId: data.sellerId,
		bidType: data.bidType,
		offerAmount: data.offerAmount,
		zollarBid: data.zollarBid || {},
		sessionId: localStorage.getItem('sessionId')
	  });

	const doHttp = () =>
	  fetch(`${apiBaseUrl}/api/button/acceptBuyOffer`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
		body: JSON.stringify({
		  buyerId: data.buyerId,
		  sellerId: data.sellerId,
		  itemId: data.itemId,
		  offerAmount: data.offerAmount,
		  bidType: data.bidType,
		  zollarBid: data.zollarBid || {},
		  sessionId: localStorage.getItem('sessionId')
		})
	  }).then(r => r.json()).then(result => {
		if (!result?.success) throw new Error(result?.message || 'Failed to accept the buy offer');
		return result;
	  });

	(trySocketFirst ? doSocket() : doHttp())
	  .then((result) => {
		showNotification(
		  t('offer.success_buy_offer_accepted', 'Success: Buy offer accepted for {item}')
			.replace('{item}', data.item_name || t('offer.item','item')),
		  true
		);
		closeBuyOfferPopupAfterAccept();
		resolve(result);
	  })
	  .catch(async (err) => {
		// Fallback to HTTP if socket path failed
		if (trySocketFirst) {
		  try {
			const result = await doHttp();
			showNotification(
			  t('offer.success_buy_offer_accepted', 'Success: Buy offer accepted for {item}')
				.replace('{item}', data.item_name || t('offer.item','item')),
			  true
			);
			closeBuyOfferPopupAfterAccept();
			resolve(result);
			return;
		  } catch (err2) {
			console.error('Failed via socket and HTTP:', err2);
			showNotification(`Error: ${err2.message}`, false);
			reject(err2);
			return;
		  }
		} else {
		  console.error('Failed to process the transaction:', err);
		  showNotification(`Error: ${err.message}`, false);
		  reject(err);
		}
	  })
	  .finally(() => { isProcessing = false; });
  });
}


// Function to handle rejected buy offer
export function handleRejectBuyOffer(data) {
  console.log('Handling rejected buy offer:', data);
  // If you want to notify server about explicit declines, emit here:
	// if (socket && socket.connected) socket.emit('rejectBuyOffer', { ...data, sessionId: localStorage.getItem('sessionId') });
	showNotification(t('offer.buy_offer_declined','Buy offer declined.'), false);
  closeBuyOfferPopupAfterDecline();

}

// Socket-based buy offer acceptance for bots
export async function acceptBuyOfferSocket(data) {
  return new Promise((resolve, reject) => {
	const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	if (!s) return reject(new Error('Socket not available'));
	if (!s.connected) return reject(new Error('Socket is not connected'));

	const message = {
	  itemId: data.itemId,
	  buyerId: data.buyerId,
	  sellerId: data.sellerId,
	  sessionId: data.sessionId || localStorage.getItem('sessionId'),
	  bidType: data.bidType,
	  offerAmount: data.offerAmount,
	  zollarBid: data.zollarBid || {}
	};

	let resolved = false;
	const timeout = setTimeout(() => {
	  if (!resolved) {
		resolved = true;
		reject(new Error('Socket timeout - no response from server'));
	  }
	}, 8000);

	s.emit('acceptBuyOfferSocket', message, (response) => {
	  if (resolved) return;
	  resolved = true;
	  clearTimeout(timeout);
	  if (response?.success) {
		console.log('Buy offer accepted via socket:', response);
		resolve(response);
	  } else {
		const errorMsg = response?.error || 'No response from server';
		reject(new Error(errorMsg));
	  }
	});
  });
}




function getQualitativeDescriptor(quantity) {
  if (quantity === 0) return t('offer.zollar_none', 'None');
  if (quantity <= 3) return t('offer.zollar_few', 'A Few');
  if (quantity <= 7) return t('offer.zollar_some', 'Some');
  if (quantity <= 15) return t('offer.zollar_many', 'Many');
  return t('offer.zollar_huge', 'A Huge Amount');
}


function closeBuyOfferPopupAfterAccept() {
  const popup = document.getElementById('buyOfferPopup');
  if (popup) {
	if (window.popupTracker) {
	  window.popupTracker.unregisterPopup('buyOfferPopup');
	}
	popup.remove();
	document.body.style.overflow = '';
  }
}

function closeBuyOfferPopupAfterDecline() {
  const popup = document.getElementById('buyOfferPopup');
  if (popup) {
	if (window.popupTracker) {
	  window.popupTracker.unregisterPopup('buyOfferPopup');
	}
	popup.remove();
	document.body.style.overflow = '';
  }
}


function showLoadingIndicator() {
  const popupContainer = document.getElementById('popup-container');
  if (popupContainer) {
	const loadingText = document.createElement("p");
	loadingText.textContent = t('offer.processing', 'Processing transaction...');
	loadingText.style.color = "#00ff00";
	popupContainer.appendChild(loadingText);
  }
}

function makeClientMessageId() {
  return `msg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function showStoryCustomizationForm(itemId, itemName, targetUsers, transactionData) {
  // Create overlay
  const overlay = document.createElement("div");
  overlay.id = 'storyCustomizationOverlay';
  overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";

  // Create form container
  const formContainer = document.createElement("div");
  formContainer.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%;";

  formContainer.innerHTML = `
    <h2 style="text-align:center;margin-bottom:20px;">
      ${t('offer.customize_story_element', 'Customize Your Story Element')}
    </h2>

    <p style="font-style:italic;margin-bottom:15px;font-size:.9em;">
      "${t('offer.story_element_description',
        'Each trade shapes your story. Describe how you want this element to appear in the final narrative.')}"
    </p>

    <div style="margin-bottom:15px;background:rgba(0,255,0,0.1);padding:10px;border-radius:5px;">
      <strong>${t('offer.trading_item', 'Trading Item:')} </strong> ${itemName}
    </div>

    <div style="margin-bottom:15px;">
      <label style="display:block;margin-bottom:5px;">
        ${t('offer.how_customize', 'How would you like to customize this story element?')}
      </label>
      <textarea id="story-customization-text"
                placeholder="${t('offer.customization_placeholder',
                  'Describe your vision for this story element... (e.g., character traits, setting details, plot twists)')}"
                style="width:100%;height:100px;padding:8px;background:rgba(36,65,192,.8);
                       color:#00ff00;border:1px solid #00ff00;resize:vertical;box-sizing:border-box;"
                maxlength="300"></textarea>
      <div style="text-align:right;font-size:.7em;margin-top:5px;">
        <span id="custom-char-count">0</span>/300
      </div>
    </div>

    <div style="display:flex;gap:10px;">
      <button id="cancel-story-customization"
              style="flex:1;padding:10px;background:rgba(255,0,0,.6);color:#fff;
                     border:1px solid #ff0000;cursor:pointer;border-radius:3px;">
        ${t('offer.cancel', 'Cancel')}
      </button>
      <button id="submit-story-customization"
              style="flex:1;padding:10px;background:rgba(0,255,0,.6);color:#000;
                     border:1px solid #00ff00;cursor:pointer;border-radius:3px;" disabled>
        ${t('offer.continue_trade', 'Continue Trade')}
      </button>
    </div>
  `;

  overlay.appendChild(formContainer);
  document.body.appendChild(overlay);

  if (window.popupTracker) {
    window.popupTracker.trackElement(overlay, 'story-customization-form');
  }

  // Add event listeners
  const customizationTextarea = document.getElementById('story-customization-text');
  const charCount = document.getElementById('custom-char-count');
  const submitButton = document.getElementById('submit-story-customization');
  const cancelButton = document.getElementById('cancel-story-customization');

  // Character counter and validation
  customizationTextarea.addEventListener('input', () => {
    const length = customizationTextarea.value.length;
    charCount.textContent = length;

    const isValid = customizationTextarea.value.trim().length >= 10;
    submitButton.disabled = !isValid;
    submitButton.style.opacity = isValid ? '1' : '0.5';
  });

  // Cancel button
  cancelButton.addEventListener('click', () => {
    document.body.removeChild(overlay);
  });

  // Submit button
  submitButton.addEventListener('click', async () => {
    const customization = customizationTextarea.value.trim();

    try {
      submitButton.disabled = true;
      submitButton.textContent = t('offer.saving', 'Saving...');

      // Save the customization to the backend
      const portfolioId = localStorage.getItem('portfolioId');
      const response = await fetch(`${apiBaseUrl}/api/storysim/save-customization`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          portfolioId,
          itemId,
          itemName,
          customization
        })
      });

      const result = await response.json();

      if (result.success) {
        document.body.removeChild(overlay);

        // Store customization in transaction data for the offer
        if (transactionData) {
          transactionData.storyCustomization = customization;
        }

        showNotification(
          t('offer.customization_saved', 'Story element customized!'),
          true
        );

        // Now proceed with the actual trade offer (call original transaction logic)
        // This will be handled by the calling function
        if (window.proceedWithStoryTrade) {
          window.proceedWithStoryTrade(customization);
        }
      } else {
        throw new Error(result.error || 'Failed to save customization');
      }

    } catch (error) {
      console.error('Error saving story customization:', error);
      showNotification(t('offer.error_generic', 'Error: {message}').replace('{message}', error.message), false);
      submitButton.textContent = t('offer.continue_trade', 'Continue Trade');
      submitButton.disabled = false;
    }
  });
}

export function showSocialTradeForm(itemId, targetUsers) {
  // Create overlay
  const overlay = document.createElement("div");
  overlay.id = 'offerSentOverlay';
  overlay.style = "position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 10000; justify-content: center; align-items: center; display: flex;";

  // Create form container
  const formContainer = document.createElement("div");
  formContainer.style = "background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%;";
  
 formContainer.innerHTML = `
   <h2 style="text-align:center;margin-bottom:20px;">
	 ${t('offer.meaningful_exchange', 'Meaningful Exchange')}
   </h2>
 
   <p style="font-style:italic;margin-bottom:15px;font-size:.7em;">
	 "${t('offer.value_quote',
	   'Value exists in perception, play and speculation, not just utility or rarity.')}"
   </p>
 
   <div style="margin-bottom:15px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${t('offer.who_to_trade_with', 'Who would you like to trade with?')}
	 </label>
	 <select id="social-target-select"
			 style="width:100%;padding:8px;background:rgba(36,65,192,.8);
					color:#00ff00;border:1px solid #00ff00;">
	   <option value="">${t('offer.select_trader', 'Select a trader...')}</option>
	   ${targetUsers.map(u =>
		 `<option value="${u._id}">${u.name}${u.isBot ? ' 🤖' : ''}</option>`).join('')}
	 </select>
   </div>
 
   <div style="margin-bottom:15px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${t('offer.why_trade', 'Why do you want to make this trade?')}
	 </label>
	 <textarea id="social-trade-reason"
			   placeholder="${t('offer.describe_motivation',
				 'Describe your motivation, emotion or story...')}"
			   style="width:100%;height:80px;padding:8px;background:rgba(36,65,192,.8);
					  color:#00ff00;border:1px solid #00ff00;resize:none;"
			   maxlength="500"></textarea>
	 <div style="text-align:right;font-size:.7em;margin-top:5px;">
	   <span id="char-count">0</span>/500
	 </div>
   </div>
 
   <div style="margin-bottom:20px;">
	 <label style="display:block;margin-bottom:5px;">
	   ${t('offer.trade_with', 'Trade with:')}
	 </label>
	 <div style="display:flex;gap:15px;">
	   <label style="display:flex;align-items:center;">
		 <input type="radio" name="bidType" value="points" checked style="margin-right:5px;">
		 ${t('offer.capital', 'Capital')}
	   </label>
	   <label style="display:flex;align-items:center;">
		 <input type="radio" name="bidType" value="zollars" style="margin-right:5px;">
		 ${t('offer.zollars', 'Zollars')}
	   </label>
	 </div>
   </div>
 
   <div style="display:flex;gap:10px;">
	 <button id="cancel-social-trade"
			 style="flex:1;padding:10px;background:rgba(255,0,0,.6);color:#fff;
					border:1px solid #ff0000;cursor:pointer;">
	   ${t('offer.cancel', 'Cancel')}
	 </button>
	 <button id="submit-social-trade"
			 style="flex:1;padding:10px;background:rgba(0,255,0,.6);color:#000;
					border:1px solid #00ff00;cursor:pointer;" disabled>
	   ${t('offer.send_offer', 'Send Offer')}
	 </button>
   </div>
 `;
  
  overlay.appendChild(formContainer);
  document.body.appendChild(overlay);
  
  if (window.popupTracker) {
	  window.popupTracker.trackElement(overlay, 'social-trade-form');
	}
	
  // Add event listeners
  const targetSelect = document.getElementById('social-target-select');
  const reasonTextarea = document.getElementById('social-trade-reason');
  const charCount = document.getElementById('char-count');
  const submitButton = document.getElementById('submit-social-trade');
  const cancelButton = document.getElementById('cancel-social-trade');
  
  // Character counter and validation
  reasonTextarea.addEventListener('input', () => {
	const length = reasonTextarea.value.length;
	charCount.textContent = length;
	
	const isValid = targetSelect.value && reasonTextarea.value.trim().length >= 10;
	submitButton.disabled = !isValid;
	submitButton.style.opacity = isValid ? '1' : '0.5';
  });
  
  targetSelect.addEventListener('change', () => {
	const isValid = targetSelect.value && reasonTextarea.value.trim().length >= 10;
	submitButton.disabled = !isValid;
	submitButton.style.opacity = isValid ? '1' : '0.5';
  });
  
  // Cancel button
  cancelButton.addEventListener('click', () => {
	document.body.removeChild(overlay);
  });
  
  // Submit button  
  submitButton.addEventListener('click', async () => {
	const targetUserId = targetSelect.value;
	const reason = reasonTextarea.value.trim();
	const bidType = document.querySelector('input[name="bidType"]:checked').value;
	
	try {
	  submitButton.disabled = true;
	  submitButton.textContent = t('offer.sending', 'Sending...');
	  
	  const response = await fetch(`${apiBaseUrl}/api/social-trade-offer`, {
		method: 'POST',
		headers: {
		  'Content-Type': 'application/json',
		  'Authorization': `Bearer ${localStorage.getItem('token')}`
		},
		body: JSON.stringify({
		  itemId,
		  targetUserId,
		  reason,
		  bidType
		})
	  });
	  
	  const result = await response.json();
	  
	  if (result.success) {
		document.body.removeChild(overlay);
		showNotification(
		  t('offer.meaningful_offer_sent', 'Meaningful trade offer sent! {insight}')
			.replace('{insight}', result.llmInsight || ''),
		  true
		);

		
		// Show the existing offer sent popup
		localStorage.setItem('pendingOffer', 'true');
		showOfferSentPopup(localStorage.getItem('portfolioId'), []);
	  } else {
		throw new Error(result.error || 'Failed to send offer');
	  }
	  
	} catch (error) {
	  console.error('Error sending social trade offer:', error);
	  showNotification(t('offer.error_generic', 'Error: {message}').replace('{message}', error.message), false);
	  submitButton.textContent = t('offer.send_meaningful_offer', 'Send Meaningful Offer');
	  submitButton.disabled = false;

	}
  });
}

export function showSocialTradeDialog(itemId, itemName, targetPortfolioId, targetPortfolioName) {
  const portfolioId = localStorage.getItem('portfolioId');
  const userPortfolioName = localStorage.getItem('portfolioName') || 'Your Portfolio';
  
  // Create the dialog
  const dialog = document.createElement('div');
  dialog.className = 'social-trade-overlay';
  dialog.id = 'social-trade-dialog'; // Add ID for easier removal
  dialog.style.cssText = `
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	font-family: 'bithigh', monospace;
  `;

dialog.innerHTML = `
	<div style="background:linear-gradient(135deg,#001122 0%,#003344 100%);
				border:2px solid #00ff00;border-radius:5px;padding:30px;
				max-width:500px;width:90%;color:#00ff00;box-shadow:0 0 30px rgba(0,255,0,.3);">
	  <h2 style="margin:0 0 20px;text-align:center;color:#00ff00;">
		${t('transaction.explain_trade_reason', 'Explain why you want to make this trade.')}
	  </h2>
  
	  <div style="margin-bottom:20px;padding:15px;background:rgba(0,255,0,.1);border-radius:5px;">
		<p style="margin:0;font-size:12px;">
		  <strong>${t('transaction.item_name', 'Item')}:</strong> ${itemName}<br>
		  <strong>${t('market.owner', 'Owner')}:</strong> ${targetPortfolioName}<br>
		  <strong>${t('trader.your_portfolio', 'Your Portfolio')}:</strong> ${userPortfolioName}
		</p>
	  </div>
  
	  <div style="margin-bottom:20px;">
		<label style="display:block;margin-bottom:10px;font-weight:bold;">
		  ${t('transaction.why_trade_question', 'Why do you want to make this trade? What is your goal?')}
		</label>
		<textarea id="tradeStoryText"
				  placeholder="${tr('offer.share_reason_placeholder',
					'Share your reason, motivation, memory, or vision... To create meaningful connections by trading.')}"
				  style="width:100%;height:120px;background:rgba(0,0,0,.7);
						 border:1px solid #00ff00;color:#00ff00;padding:10px;
						 border-radius:2px;font-family:'bithigh',Arial,sans-serif;
						 font-size:12px;resize:vertical;box-sizing:border-box;"
				  required></textarea>
		<div id="storyError"
			 style="color:#ff0000;font-size:12px;margin-top:5px;display:none;">
		  ${t('transaction.narrative_error',
			   'Please write at least 15 characters to explain your goal.')}
		</div>
	  </div>
  
	  <div style="display:flex;gap:15px;justify-content:center;">
		<button id="sendTradeStory"
				style="background:linear-gradient(45deg,#00ff00,#00aa00);color:#000;
					   border:none;padding:12px 25px;border-radius:3px;cursor:pointer;
					   font-weight:bold;font-family:'bithigh',Arial,sans-serif;">
		  ${t('transaction.send_trade_with_intention', 'Send trade with intention')}
		</button>
		<button id="cancelTradeStory"
				style="background:linear-gradient(45deg,#666,#444);color:#fff;
					   border:none;padding:12px 25px;border-radius:4px;cursor:pointer;
					   font-family:'bithigh',Arial,sans-serif;">
		  ${tr('offer.cancel', 'Cancel')}
		</button>
	  </div>
	</div>
  `;

  document.body.appendChild(dialog);
  
  if (window.popupTracker) {
	const popupHandle = window.popupTracker.trackElement(dialog, 'social-trade-dialog');
  }
  // Handle send button
  const sendButton = document.getElementById('sendTradeStory');
  const cancelButton = document.getElementById('cancelTradeStory');
  const storyTextarea = document.getElementById('tradeStoryText');
  const errorDiv = document.getElementById('storyError');

  sendButton.onclick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	
	const storyText = storyTextarea.value.trim();
	
	if (!storyText || storyText.length < 10) {
	  errorDiv.style.display = 'block';
	  errorDiv.textContent = t('offer.response_min_10', 'Please write at least 10 characters about why you want this asset.');
	  storyTextarea.focus();
	  return;
	}

	// Store the story in localStorage for the transaction page
	localStorage.setItem('tradeStory', storyText);
	localStorage.setItem('tradeStoryTimestamp', new Date().toISOString());
	
	// Remove dialog
	dialog.remove();
	
	// Navigate to transaction page with story flag
	const url = `transaction.html?itemId=${encodeURIComponent(itemId)}&itemName=${encodeURIComponent(itemName)}&portfolioId=${encodeURIComponent(targetPortfolioId)}&portfolioName=${encodeURIComponent(targetPortfolioName)}&hasStory=true`;
	console.log('Navigating to:', url);
	window.location.href = url;
  };

  // Handle cancel button
  cancelButton.onclick = (e) => {
	e.preventDefault();
	e.stopPropagation();
	console.log('Cancel button clicked');
	dialog.remove();
  };

  // Handle escape key
  const escapeHandler = (e) => {
	if (e.key === 'Escape') {
	  dialog.remove();
	  document.removeEventListener('keydown', escapeHandler);
	}
  };
  document.addEventListener('keydown', escapeHandler);

  // Focus on textarea
  setTimeout(() => {
	storyTextarea.focus();
  }, 100);

  // Add click outside to close (optional)
  dialog.addEventListener('click', (e) => {
	if (e.target === dialog) {
	  dialog.remove();
	}
  });
}

export function showSocialTradeReceived(data) {
  // Guard & destructure safely
  if (!data || typeof data !== 'object') return;
  const {
	itemName = t?.('offer.item','item'),
	reason = '',
	initiatorName = t?.('offer.trader','Trader'),
	initiatorUserId, // recipient on reply
	itemId
  } = data;

  // Must have these to route replies
  if (!initiatorUserId || !itemId) {
	console.warn('showSocialTradeReceived: missing initiatorUserId or itemId', data);
	return;
  }

  // Socket must be available now
  const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
  if (!s || !s.connected) {
	showNotification(t('offer.error_no_socket','Not connected. Please try again.'), false);
	return;
  }

  // DOM
  const overlay = document.createElement('div');
  overlay.style =
	"position: fixed; top: 0; left: 0; width: 100%; height: 100%;" +
	"background: rgba(0,0,0,0.8); z-index: 9999; display: flex; justify-content: center; align-items: center;";

  const popup = document.createElement('div');
  popup.style =
	"background: rgba(1, 32, 59, 0.95); border: 2px solid #00ff00; color: #00ff00; padding: 20px;" +
	"border-radius: 5px; max-width: 500px; width: 90%; font-family: 'bithigh', sans-serif;";

  popup.innerHTML = `
	<h4 style="margin-top:0; text-align:center;">
	  ${t('offer.meaningful_trade_offer','Meaningful Trade Offer')}
	</h4>
	<div style="margin-bottom:15px;">
	  <strong>${initiatorName}</strong> ${t('offer.wants_to_trade','wants to trade')}
	  <strong>${itemName}</strong>
	</div>
	<div style="background: rgba(0,0,0,0.3); padding: 10px; border-radius: 3px; margin-bottom: 15px; font-style: italic;">
	  "${reason || ''}"
	</div>
	<textarea id="response-message"
	  placeholder="${t('offer.respond_optional','Respond to their story (optional)...')}"
	  style="width:100%; height:60px; padding:8px; background: rgba(36,65,192,0.8); color:#00ff00;
			 border:1px solid #00ff00; resize:none; margin-bottom:15px;"
	  maxlength="200"></textarea>
	<div style="display:flex; gap:10px;">
	  <button id="not-interested" style="flex:1; padding:10px; background: rgba(255,0,0,0.6); color:#fff; border:1px solid #ff0000; cursor:pointer;">
		${t('offer.not_interested','Not Interested')}
	  </button>
	  <button id="interested" style="flex:1; padding:10px; background: rgba(0,255,0,0.6); color:#000; border:1px solid #00ff00; cursor:pointer;">
		${t('offer.im_interested',"I'm Interested!")}
	  </button>
	</div>
  `;

  overlay.appendChild(popup);
  document.body.appendChild(overlay);
  if (window.popupTracker) window.popupTracker.trackElement(overlay, 'social-trade-received');

  const autoClose = setTimeout(removeOverlay, 30000);
  function removeOverlay() {
	clearTimeout(autoClose);
	if (document.body.contains(overlay)) document.body.removeChild(overlay);
  }

  // Close on ESC and click-outside
  const onEsc = (e) => { if (e.key === 'Escape') removeOverlay(); };
  document.addEventListener('keydown', onEsc);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) removeOverlay(); });

  // Common send routine (no waitForReadySocket; we already checked)
  function sendReply({ interested }) {
	const message = (document.getElementById('response-message')?.value || '').trim();
	const myPortfolioId = getPortfolioId();
	const content = message || (interested
	  ? t('offer.default_interested',"I'm interested in this trade!")
	  : t('offer.default_not_interested','Not interested in this trade.')
	);

	if (!s || !s.connected) {
	  showNotification(t('offer.error_no_socket','Not connected. Please try again.'), false);
	  return;
	}

	s.emit('socialTradeResponse', {
	  initiatorUserId,
	  targetUserId: myPortfolioId,
	  itemId,
	  interested: !!interested,
	  message: content
	}, (ack) => {
	  if (ack && ack.success === false) {
		showNotification((t('offer.error_sending','Error: {m}')).replace('{m}', ack.error || 'Failed to send'), false);
		return;
	  }
	  removeOverlay();
	  showNotification(
		interested
		  ? t('offer.interest_shown','Interest shown! They may contact you directly.')
		  : t('offer.response_sent','Response sent'),
		!!interested
	  );
	});
  }

  // Wire buttons
  popup.querySelector('#not-interested').addEventListener('click', () => sendReply({ interested: false }));
  popup.querySelector('#interested').addEventListener('click', () => sendReply({ interested: true }));
}



// Function to show responses to your social trade offers
export function showSocialTradeResponse(data) {
  const { responderName, interested, message } = data;
  const emotion = interested ? 'yes' : 'meh';
  const color = interested ? 'rgba(0, 255, 0, 0.8)' : 'rgba(255, 165, 0, 0.8)';
  
  showNotification(
	`${emotion} ${responderName}: "${message}"`, 
	interested
  );
}

function showNarrativeResponseDialog(offerData) {
  const overlay = document.createElement('div');
  overlay.style.cssText = `
	position: fixed; top: 0; left: 0; width: 100%; height: 100%;
	background: rgba(0,0,0,0.9); z-index: 10001;
	display: flex; align-items: flex-start; justify-content: center;
	overflow-y: auto; overflow-x: hidden; padding: 20px 0; box-sizing: border-box;
  `;

  const dialog = document.createElement('div');
  dialog.style.cssText = `
	background: linear-gradient(135deg, #001122 0%, #003344 100%);
	border: 2px solid #00ff00; border-radius: 10px; padding: 30px;
	max-width: 500px; width: 90%; color: #00ff00; font-family: 'bithigh', monospace;
	margin: auto; max-height: calc(100vh - 40px); overflow-y: auto; box-sizing: border-box; position: relative;
  `;
  dialog.innerHTML = `
	<h5 style="margin: 0 0 15px 0; text-align: center;">${t('offer.respond_to_offer','Respond to offer.')}</h5>
	<div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
	  <strong>${t('offer.the_why','The why:')}</strong><br>
	  <em>"${offerData.tradeStory || ''}"</em>
	</div>
	<textarea id="responseText" placeholder="${t('offer.response_placeholder','Share your thoughts, ask questions, or explain your perspective...')}"
	  style="width: 100%; height: 100px; background: rgba(0,0,0,0.7); border: 1px solid #00ff00; color: #00ff00; padding: 10px; border-radius: 3px; font-family: 'bithigh', Arial, sans-serif; resize: vertical; box-sizing: border-box;" maxlength="300" required></textarea>
	<div style="text-align: right; font-size: 0.8em; margin: 5px 0;">
	  <span id="responseCharCount">0</span>/300
	</div>
	<div id="responseError" style="color: #ff0000; font-size: 12px; margin: 5px 0; display: none;">
	  ${t('offer.response_min_chars','Please write at least 10 characters in your response.')}
	</div>
	<div style="display: flex; gap: 10px; margin-top: 15px;">
	  <button id="sendResponse" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 5px;">
		${t('offer.send_response','Send Response')}
	  </button>
	  <button id="cancelResponse" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 5px;">
		${t('offer.cancel','Cancel')}
	  </button>
	</div>
  `;

  overlay.appendChild(dialog);
  document.body.appendChild(overlay);
  document.body.style.overflow = 'hidden';

  if (window.popupTracker) window.popupTracker.trackElement(overlay, 'narrative-response');

  const responseText = dialog.querySelector('#responseText');
  const charCount = dialog.querySelector('#responseCharCount');
  const sendButton = dialog.querySelector('#sendResponse');
  const cancelButton = dialog.querySelector('#cancelResponse');
  const errorDiv = dialog.querySelector('#responseError');

  let listenerAttached = false;
  let sending = false;

  responseText.addEventListener('input', () => {
	charCount.textContent = responseText.value.length;
	if (responseText.value.length > 0) errorDiv.style.display = 'none';
  });

  const cleanup = () => {
	const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	if (listenerAttached && s) s.off('llmResponseReceived', handleLLMResponse);
	listenerAttached = false;
	document.body.style.overflow = '';
	if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  };

  cancelButton.onclick = (e) => {
	e.preventDefault();
	if (sending) return;
	cleanup();
  };

  function handleLLMResponse(data) {
	if (!data?.originalOffer) return;
	const match = (
	  data.originalOffer.offeredItemId === offerData.offeredItemId &&
	  data.originalOffer.transactionItemId === offerData.transactionItemId
	);
	if (!match) return;

	// Update dialog with bot response
	dialog.innerHTML = `
	  <h4 style="margin: 0 0 15px 0; text-align: center;">${t('offer.they_responded','They Responded')}</h4>
	  <div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 10px;">
		<strong>${t('offer.their_original_why','Their original why:')}</strong><br>
		<em>"${offerData.tradeStory || ''}"</em>
	  </div>
	  <div style="background: rgba(0,100,255,0.1); padding: 10px; border-radius: 5px; margin-bottom: 10px;">
		<strong>${t('offer.your_response','Your response:')}</strong><br>
		<em>"${data.userResponse || ''}"</em>
	  </div>
	  <div style="background: rgba(255,165,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		<strong>${t('offer.their_response','Their response:')}</strong><br>
		<em>"${data.botResponse || ''}"</em>
	  </div>
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="finalAcceptFromDialog" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000; border: 1px solid #00ff00; padding: 10px; cursor: pointer; border-radius: 5px;">
		  ${t('offer.accept','Accept')}
		</button>
		<button id="finalDeclineFromDialog" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff; border: 1px solid #ff0000; padding: 10px; cursor: pointer; border-radius: 5px;">
		  ${t('offer.decline','Decline')}
		</button>
	  </div>
	`;

	const finalAccept = dialog.querySelector('#finalAcceptFromDialog');
	const finalDecline = dialog.querySelector('#finalDeclineFromDialog');

	finalAccept.onclick = async () => {
	  try { await acceptTrade(offerData); cleanup(); const original = document.getElementById('tradeOfferPopup'); if (original) original.remove(); }
	  catch (e) { showNotification(`${t('offer.error_accepting_offer','Error accepting offer: {message}').replace('{message}', e.message)}`, false); }
	};
	finalDecline.onclick = async () => {
	  try { await declineTrade(offerData); cleanup(); const original = document.getElementById('tradeOfferPopup'); if (original) original.remove(); }
	  catch (e) { showNotification(`${t('offer.error_declining_offer','Error declining offer: {message}').replace('{message}', e.message)}`, false); }
	};

	// detach, handled once
	const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	if (listenerAttached && s) {
	  s.off('llmResponseReceived', handleLLMResponse);
	  listenerAttached = false;
	}
  }

  sendButton.onclick = async (e) => {
	e.preventDefault();
	if (sending) return;
	const response = responseText.value.trim();
	if (!response || response.length < 10) {
	  errorDiv.style.display = 'block';
	  errorDiv.textContent = t('offer.response_min_chars','Please write at least 10 characters in your response.');
	  responseText.focus();
	  return;
	}

	try {
	  sending = true;
	  sendButton.disabled = true;
	  sendButton.textContent = t('offer.sending','Sending...');
	  sendButton.style.opacity = '0.5';

	  const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	  if (!s || !s.connected) throw new Error('Socket connection not available');

	  s.emit('requestLlmResponseOffer', {
		originalOffer: offerData,
		userResponse: response,
		responderUserId: localStorage.getItem('portfolioId')
	  }, (ack) => {
		if (!ack?.success) showNotification(`Error: ${ack?.error || 'LLM request failed'}`, false);
	  });

	  dialog.innerHTML = `
		<h3 style="margin: 0 0 15px 0; text-align: center;">${t('offer.response_sent','Response Sent')}</h3>
		<div style="background: rgba(0,255,0,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		  <strong>${t('offer.the_why','The why:')}</strong><br>
		  <em>"${offerData.tradeStory || ''}"</em>
		</div>
		<div style="background: rgba(0,100,255,0.1); padding: 10px; border-radius: 5px; margin-bottom: 15px;">
		  <strong>${t('offer.your_response','Your response:')}</strong><br>
		  <em>"${response}"</em>
		</div>
		<div style="text-align: center; color: #ffaa00;">
		  <p>${t('offer.waiting_for_their_response','Waiting for their response...')}</p>
		  <p style="font-size: 0.9em; color: #00ff00;">${t('offer.timer_extended','Timer extended to 60 seconds')}</p>
		</div>
	  `;

	  // listen once (guard against stacking)
	  if (!listenerAttached && s) {
		s.off('llmResponseReceived', handleLLMResponse);
		s.on('llmResponseReceived', handleLLMResponse);
		listenerAttached = true;
	  }
	  showNotification(t('offer.response_sent_wait','Response sent! Waiting for their response...'), true);
	} catch (err) {
	  showNotification(`Error: ${err.message}`, false);
	  sending = false;
	  sendButton.disabled = false;
	  sendButton.textContent = t('offer.send_response','Send Response');
	  sendButton.style.opacity = '1';
	}
  };

  // Escape & outside to close
  const escapeHandler = (e) => { if (e.key === 'Escape' && !sending) { cleanup(); document.removeEventListener('keydown', escapeHandler); } };
  document.addEventListener('keydown', escapeHandler);
  setTimeout(()=>responseText.focus(),100);
  overlay.addEventListener('click', (e) => { if (e.target === overlay && !sending) cleanup(); });
}


function showUpdatedOfferPopup(offerData) {
  if (!offerData) return;

  // Remove existing popup
  const existingPopup = document.getElementById('tradeOfferPopup');
  if (existingPopup) existingPopup.remove();

  // Show new popup with narrative exchange
  const popup = document.createElement('div');
  popup.id = 'tradeOfferPopup';
  popup.style.cssText = `
	position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);
	width: 100%; max-width: 100%; height: 100%; max-height: 100%;
	border-radius: 0px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); z-index: 9999;
	font-family: 'bithigh', Arial, sans-serif; color: #00ff00;
	text-align: center; align-content: center; overflow: hidden;
  `;

  let exchangeHtml = '';
  if (Array.isArray(offerData.narrativeExchange) && offerData.narrativeExchange.length > 0) {
	exchangeHtml = `
	  <div style="background: rgba(0,255,0,0.1); border: 1px solid rgba(0,255,0,0.3);
				  border-radius: 3px; padding: 10px; margin: 15px 0; max-height: 200px; overflow-y: auto;">
		<h5 style="margin: 0 0 10px 0;">${t('offer.conversation','Conversation:')}</h5>
		${offerData.narrativeExchange.map(msg => `
		  <div style="margin: 5px 0; padding: 5px; background: rgba(0,0,0,0.3); border-radius: 3px;">
			<strong>${
			  msg.from === offerData.initiatorUserId
				? (offerData.initiatorPortfolioName || t('offer.trader','Trader'))
				: t('offer.you','You')
			}:</strong>
			<span style="font-style: italic;">"${(msg.message ?? '').toString()}"</span>
		  </div>
		`).join('')}
	  </div>
	`;
  }

  const content = document.createElement('div');
  content.style.cssText = `position: relative; z-index: 1; padding: 20px; border-radius: 10px;`;
  content.innerHTML = `
	<div class="tradeOffPop">
	  <h2>${t('offer.updated_trade_offer', 'Updated Trade Offer')}</h2>
	  <p>${
		t('offer.offer_sentence_simple', '{name} offers you {offered} and requests {requested} in return.')
		  .replace('{name}', offerData.initiatorPortfolioName || t('offer.trader','Trader'))
		  .replace('{offered}', offerData.offeredItemName || t('offer.item','item'))
		  .replace('{requested}', offerData.transactionItemName || t('offer.item','item'))
	  }</p>
	  ${exchangeHtml}
	  <div style="display: flex; gap: 10px; margin-top: 15px;">
		<button id="finalAccept" style="flex: 1; background: rgba(0, 255, 0, 0.6); color: #000;
			   border: 1px solid #00ff00; padding: 10px; cursor: pointer;">${t('offer.accept', 'Accept')}</button>
		<button id="finalDecline" style="flex: 1; background: rgba(255, 0, 0, 0.6); color: #fff;
			   border: 1px solid #ff0000; padding: 10px; cursor: pointer;">${t('offer.decline', 'Decline')}</button>
	  </div>
	</div>
  `;

  popup.appendChild(content);
  document.body.appendChild(popup);

  if (window.popupTracker) {
	window.popupTracker.trackElement(popup, 'updated-trade-offer');
  }

  // Final decision buttons with double-click guard
  const acceptBtn = document.getElementById('finalAccept');
  const declineBtn = document.getElementById('finalDecline');
  let busy = false;

  const setBusy = (state) => {
	busy = state;
	if (acceptBtn) { acceptBtn.disabled = state; acceptBtn.style.opacity = state ? '0.6' : '1'; }
	if (declineBtn) { declineBtn.disabled = state; declineBtn.style.opacity = state ? '0.6' : '1'; }
  };

  if (acceptBtn) {
	acceptBtn.onclick = async () => {
	  if (busy) return;
	  setBusy(true);
	  try {
		await acceptTrade(offerData); // uses window.popupTrackerSocket internally
		popup.remove();
	  } catch (error) {
		console.error('Error accepting trade:', error);
		showNotification(`${t('offer.error_accepting_offer','Error accepting offer: {message}').replace('{message}', error.message)}`, false);
		setBusy(false);
	  }
	};
  }

  if (declineBtn) {
	declineBtn.onclick = async () => {
	  if (busy) return;
	  setBusy(true);
	  try {
		await declineTrade(offerData); // uses window.popupTrackerSocket internally
		popup.remove();
	  } catch (error) {
		console.error('Error declining trade:', error);
		showNotification(`${t('offer.error_declining_offer','Error declining offer: {message}').replace('{message}', error.message)}`, false);
		setBusy(false);
	  }
	};
  }
}

// Handle when someone accepts your buy offer
// Handle when someone accepts your buy offer (safer + cleans up any lingering popups)
export function handleBuyOfferAcceptedByOther(data) {
  if (!data || typeof data !== 'object') {
	console.warn('handleBuyOfferAcceptedByOther: missing/invalid payload', data);
	return;
  }

  // Try to clean up any UI remnants from the offer flow
  ['popup-container', 'offerSentPopup', 'offerSentOverlay', 'tradeOfferPopup'].forEach(id => {
	const el = document.getElementById(id);
	if (el) {
	  // Unregister from popupTracker before removing
	  if (window.popupTracker) {
		window.popupTracker.unregisterPopup(id);
	  }
	  el.remove();
	}
  });

  // Call the global cleanup function if it exists
  if (window.cleanupOfferSentPopup) {
	try {
	  window.cleanupOfferSentPopup();
	} catch (e) {
	  console.warn('Error calling cleanupOfferSentPopup:', e);
	}
  }

  localStorage.removeItem('pendingOffer');

  // NOTE: Notification is already shown by showProcessingAndResultPopup() in market.js
  // This function only handles cleanup and LED display updates

  // Reflect potential balance changes - LED display updated automatically
  try { updateTotalPointsDisplay(); } catch (e) { /* no-op */ }
}


// Bot trade offer handler function
// Bot trade offer handler function (robust: handles string/object, de-dupes, ACKs)
function showBotTradeOffer(tradeDataStrOrObj) {
  try {
	// 1) Parse safely (server may send an object OR a JSON string)
	const raw = (typeof tradeDataStrOrObj === 'string')
	  ? JSON.parse(tradeDataStrOrObj)
	  : (tradeDataStrOrObj || {});

	// 2) Normalize expected fields (tolerate alternate keys)
	const myId = localStorage.getItem('portfolioId');
	const offerData = {
	  initiatorUserId: raw.initiatorUserId ?? raw.botId ?? raw.fromUserId,
	  initiatorPortfolioName: raw.initiatorPortfolioName ?? raw.botName ?? t('offer.trader','Trader'),
	  targetUserId: raw.targetUserId ?? raw.toUserId ?? myId,
	  offeredItemId: raw.offeredItemId ?? raw.offered_id ?? raw.offerItemId,
	  transactionItemId: raw.transactionItemId ?? raw.requested_id ?? raw.requestItemId,
	  offeredItemName: raw.offeredItemName ?? raw.offerName ?? t('offer.item','item'),
	  transactionItemName: raw.transactionItemName ?? raw.requestName ?? t('offer.item','item'),
	  narrativeExchange: Array.isArray(raw.narrativeExchange) ? raw.narrativeExchange : (raw.exchange || []),
	  tradeStory: raw.tradeStory ?? raw.story ?? '',
	  expiresAt: raw.expiresAt ?? raw.expireAt ?? null,
	  // include all original fields in case your UI needs more
	  ...raw,
	};

	// 3) Only show if it's actually for this user (when explicitly targeted)
	if (offerData.targetUserId && offerData.targetUserId !== myId) {
	  console.warn('Bot trade offer not for this user. Skipping.', { myId, target: offerData.targetUserId });
	  return;
	}

	// 4) De-duplicate: compute a stable message id and suppress repeats for 30s
	const msgId =
	  raw.msgId ||
	  `${offerData.initiatorUserId || 'bot'}:${myId}:${offerData.offeredItemId || ''}:${offerData.transactionItemId || ''}:${raw.timestamp || ''}`;

	const now = Date.now();
	window._botOfferSeen = window._botOfferSeen || new Map();
	const seen = window._botOfferSeen.get(msgId);
	if (seen && (now - seen) < 30000) {
	  // Already processed recently; skip duplicate
	  return;
	}
	window._botOfferSeen.set(msgId, now);
	// Optional prune to prevent unbounded growth
	if (window._botOfferSeen.size > 200) {
	  // delete oldest ~50
	  let count = 0;
	  for (const k of window._botOfferSeen.keys()) {
		window._botOfferSeen.delete(k);
		if (++count >= 50) break;
	  }
	}

	// 5) ACK back to server that we displayed it (best-effort)
	try {
	  const s = (typeof window !== 'undefined') ? window.popupTrackerSocket : null;
	  if (s && s.connected) {
		s.emit('ackBotTradeOffer', { msgId, recipientId: myId }, () => {});
	  }
	} catch (_) {
	  // non-fatal
	}

	// 6) Finally show the popup using your existing UI
	console.log('Bot trade offer (normalized):', offerData);
	showOfferPopup(offerData, myId);
  } catch (error) {
	console.error('Error handling bot trade offer:', error, tradeDataStrOrObj);
	showNotification(t('offer.error_processing_trade', 'Error processing trade offer'), false);
  }
}


// Refresh offer texts when language changes
window.refreshOfferTexts = function() {
  console.log('Refreshing offer texts...');
  
  // Update any visible offer popups
  const offerPopup = document.getElementById('tradeOfferPopup');
  if (offerPopup) {
	const acceptBtn = offerPopup.querySelector('#acceptOffer');
	const declineBtn = offerPopup.querySelector('#declineOffer');
	if (acceptBtn) acceptBtn.textContent = t('offer.accept', 'Accept');
	if (declineBtn) declineBtn.textContent = t('offer.decline', 'Decline');
  
	// Trade popup uses <div id="timer">plain text</div> — keep it plain
	const tradeTimerEl = offerPopup.querySelector('#timer');
	if (tradeTimerEl) {
	  const text = t('offer.time_remaining', 'Time remaining: {seconds} seconds')
		.replace('{seconds}', tradeTimerEl.textContent || '0');
	  // render nearby if you want, or skip since your timer already writes directly
	  // tradeTimerEl.textContent = text;
	}
  }
  
  // Update offer sent popup if present
const offerSentPopup = document.getElementById('offerSentPopup');
  if (offerSentPopup) {
	const content = offerSentPopup.querySelector('div[style*="position: relative"]');
	if (content) {
	  const current = (content.querySelector('#offerSentTimer')?.textContent) || '10';
	  const timerP = content.querySelector('#offerSentTimerText');
	  if (timerP) {
		timerP.innerHTML = t('offer.time_remaining_html','Time remaining: <span id="offerSentTimer">{seconds}</span> seconds')
		  .replace('{seconds}', current);
	  }
	}
  }
};

// Make functions globally available for integration with your existing system
window.showSocialTradeDialog = showSocialTradeDialog;
window.showBotTradeOffer = showBotTradeOffer;